export const ADMIN_IMAGE_SOURCES_PANEL_ID = 'email-maker-admin-image-sources-panel';

/** Admin-only dialog text (intentionally untranslated). */
export const ADMIN_IMAGE_SOURCES_TITLE = 'Components information';
export const ADMIN_IMAGE_SOURCES_LOADING = 'Loading…';
export const ADMIN_IMAGE_SOURCES_EMPTY = 'No image sources found.';
export const ADMIN_IMAGE_SOURCES_SOURCE_PREFIX = 'Source: ';
